// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fb-wrapper {
  width: 100%;
  background: black;
  display: flex;
  justify-content: center;
  margin: 0 0 16px;
}
.fb-wrapper > div {
  width: 896px;
  height: 560px;
}

.tt-wrapper {
  width: 100%;
  background: black;
  display: flex;
  justify-content: center;
  margin: 0 0 16px;
}
.tt-wrapper iframe {
  transform: translateY(-1px);
  border-radius: 8px;
}
.tt-wrapper > div {
  width: 896px;
  height: 560px;
}

.in-wrapper {
  width: 100%;
  background: black;
  display: flex;
  justify-content: center;
  margin: 0 0 16px;
}
.in-wrapper a {
  display: block;
}
.in-wrapper img {
  display: block;
  height: 640px;
}

.VideoModalContentLoading {
  height: 350px;
}

.video-modal-container .player-component {
  margin: 0 0 16px;
}
.video-modal-container .VideoContent-tiktok {
  min-height: 800px;
}

.video-modal-content .title-content,
.video-modal-content .title-actions-content {
  margin: 0 0 32px;
}
.video-modal-content .video-info,
.video-modal-content .topics-post-link-container,
.video-modal-content .live-state,
.video-modal-content .content {
  background: transparent;
  overflow: visible;
}
.video-modal-content .video-info,
.video-modal-content .topics-post-link-container,
.video-modal-content .title-content,
.video-modal-content .chart-card,
.video-modal-content .related-videos,
.video-modal-content .live-ads-wrapper,
.video-modal-content .VideoContent-LiveGraphs {
  padding: 0 16px;
}
.video-modal-content .live-ads-wrapper {
  margin-top: 16px;
  display: flex;
  align-items: center;
}
.video-modal-content .live-ads-wrapper .YellowBadge-customStyle {
  display: flex;
  align-items: center;
  justify-content: center;
}
.video-modal-content .live-ads-wrapper .YellowBadge-customStyle svg path {
  transform: translateX(20%);
}
.video-modal-content .live-ads-wrapper div[data-testid=tooltip-wrapper]::after {
  padding-right: 10px;
  padding-left: 10px;
}
.video-modal-content .live-finished-empty-state {
  margin: 40px 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.video-modal-content .live-finished-empty-state > div {
  width: 100%;
  max-width: 700px;
  height: 250px;
}
.video-modal-content .video-info-addto-title .checkbox {
  margin-bottom: 16px;
  box-shadow: none;
}
.video-modal-content .video-info-addto-title {
  gap: 10px;
  display: flex;
}
.video-modal-content .video-info-addto-title button {
  margin-top: 3px;
}
.video-modal-content .video-info-addto-title .title {
  word-break: break-word;
  margin-bottom: 16px;
}
.video-modal-content .video-info-addto-title-with-checkbox {
  align-items: center;
}
.video-modal-content .video-modal-about {
  margin: 16px 0 32px;
}
.video-modal-content .topics-post-link-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  font-size: 16px;
  padding: 16px;
}
.video-modal-content .topics-post-link-container .header {
  margin-right: 16px;
  display: inline-block;
}
.video-modal-content .topics-post-link-container .topics-content {
  display: flex;
}
.video-modal-content .topics-post-link-container .topics-content .video-related-topics {
  color: var(--color_primary_500);
}
.video-modal-content .topics-post-link-container .post-link {
  display: block;
  font-size: 14px;
  color: var(--gray);
  margin-left: auto;
}
.video-modal-content .topics-post-link-container .post-link:hover {
  color: var(--gray_dark1);
}
.video-modal-content .info-content-grid {
  padding: 0 0 1px;
}
.video-modal-content .info-content-grid .mini-card-container .title-tooltip {
  max-width: 200px;
}
.video-modal-content .related-videos {
  margin: 0 0 32px;
}
.video-modal-content .related-videos > .title {
  margin: 0 0 8px;
}
.video-modal-content .related-videos-grid {
  display: grid;
  grid-gap: 16px;
  grid-template-columns: repeat(3, minmax(250px, 1fr));
}

.chart-side-by-side {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 20px;
  column-gap: 20px;
}

.video-modal-content .content .mini-card-container {
  padding: 0;
}
.video-modal-content .content .mini-card-container .mini-card-container-title span {
  align-self: flex-end;
}

@media only screen and (max-width: 600px) {
  .topics-post-link-container {
    display: none;
  }
  .video-modal-about {
    display: none;
  }
  .video-modal-tag-cloud-card {
    display: none;
  }
  .chart-side-by-side {
    display: none;
  }
  .related-videos {
    display: none;
  }
  .published-at {
    display: none;
  }
  .CheckboxInput {
    display: none;
  }
  div.checkbox[class*=dist_checkbox-styled] {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/VideoContent/index.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,iBAAA;EACA,aAAA;EACA,uBAAA;EACA,gBAAA;AACF;AACE;EACE,YAAA;EACA,aAAA;AACJ;;AAGA;EACE,WAAA;EACA,iBAAA;EACA,aAAA;EACA,uBAAA;EACA,gBAAA;AAAF;AAEE;EACE,2BAAA;EACA,kBAAA;AAAJ;AAGE;EACE,YAAA;EACA,aAAA;AADJ;;AAKA;EACE,WAAA;EACA,iBAAA;EACA,aAAA;EACA,uBAAA;EACA,gBAAA;AAFF;AAIE;EACE,cAAA;AAFJ;AAKE;EACE,cAAA;EACA,aAAA;AAHJ;;AAOA;EACE,aAAA;AAJF;;AAQE;EACE,gBAAA;AALJ;AAQE;EACE,iBAAA;AANJ;;AAWE;;EAEE,gBAAA;AARJ;AAWE;;;;EAIE,uBAAA;EACA,iBAAA;AATJ;AAYE;;;;;;;EAOE,eAAA;AAVJ;AAaE;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;AAXJ;AAaI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AAXN;AAcQ;EACE,0BAAA;AAZV;AAkBM;EACE,mBAAA;EACA,kBAAA;AAhBR;AAqBE;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAnBJ;AAqBI;EACE,WAAA;EACA,gBAAA;EACA,aAAA;AAnBN;AAyBM;EACE,mBAAA;EACA,gBAAA;AAvBR;AAoBI;EAME,SAAA;EACA,aAAA;AAvBN;AAyBM;EACE,eAAA;AAvBR;AA0BM;EACE,sBAAA;EACA,mBAAA;AAxBR;AA2BM;EACE,mBAAA;AAzBR;AA8BE;EACE,mBAAA;AA5BJ;AA+BE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,aAAA;AA7BJ;AA+BI;EACE,kBAAA;EACA,qBAAA;AA7BN;AAgCI;EACE,aAAA;AA9BN;AAgCM;EACE,+BAAA;AA9BR;AAkCI;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;AAhCN;AAkCM;EACE,wBAAA;AAhCR;AAqCE;EACE,gBAAA;AAnCJ;AAqCI;EACE,gBAAA;AAnCN;AAuCE;EACE,gBAAA;AArCJ;AAuCI;EACE,eAAA;AArCN;AAyCE;EACE,aAAA;EACA,cAAA;EACA,oDAAA;AAvCJ;;AA2CA;EACE,aAAA;EACA,8BAAA;EACA,qBAAA;EAAA,gBAAA;AAxCF;;AA2CA;EACE,UAAA;AAxCF;AA2CI;EACE,oBAAA;AAzCN;;AA8CA;EACE;IACE,aAAA;EA3CF;EA8CA;IACE,aAAA;EA5CF;EA+CA;IACE,aAAA;EA7CF;EAgDA;IACE,aAAA;EA9CF;EAiDA;IACE,aAAA;EA/CF;EAkDA;IACE,aAAA;EAhDF;EAmDA;IACE,aAAA;EAjDF;EAoDA;IACE,aAAA;EAlDF;AACF","sourcesContent":[".fb-wrapper {\n  width: 100%;\n  background: black;\n  display: flex;\n  justify-content: center;\n  margin: 0 0 16px;\n\n  > div {\n    width: 896px;\n    height: 560px;\n  }\n}\n\n.tt-wrapper {\n  width: 100%;\n  background: black;\n  display: flex;\n  justify-content: center;\n  margin: 0 0 16px;\n\n  iframe {\n    transform: translateY(-1px);\n    border-radius: 8px;\n  }\n\n  > div {\n    width: 896px;\n    height: 560px;\n  }\n}\n\n.in-wrapper {\n  width: 100%;\n  background: black;\n  display: flex;\n  justify-content: center;\n  margin: 0 0 16px;\n\n  a {\n    display: block;\n  }\n\n  img {\n    display: block;\n    height: 640px;\n  }\n}\n\n.VideoModalContentLoading {\n  height: 350px;\n}\n\n.video-modal-container {\n  .player-component {\n    margin: 0 0 16px;\n  }\n\n  .VideoContent-tiktok {\n    min-height: 800px;\n  }\n}\n\n.video-modal-content {\n  .title-content,\n  .title-actions-content {\n    margin: 0 0 32px;\n  }\n\n  .video-info,\n  .topics-post-link-container,\n  .live-state,\n  .content {\n    background: transparent;\n    overflow: visible;\n  }\n\n  .video-info,\n  .topics-post-link-container,\n  .title-content,\n  .chart-card,\n  .related-videos,\n  .live-ads-wrapper,\n  .VideoContent-LiveGraphs {\n    padding: 0 16px;\n  }\n\n  .live-ads-wrapper {\n    margin-top: 16px;\n    display: flex;\n    align-items: center;\n\n    .YellowBadge-customStyle {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n\n      svg {\n        path {\n          transform: translateX(20%);\n        }\n      }\n    }\n\n    div[data-testid='tooltip-wrapper'] {\n      &::after {\n        padding-right: 10px;\n        padding-left: 10px;\n      }\n    }\n  }\n\n  .live-finished-empty-state {\n    margin: 40px 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    > div {\n      width: 100%;\n      max-width: 700px;\n      height: 250px;\n    }\n  }\n\n  .video-info {\n    &-addto-title {\n      .checkbox {\n        margin-bottom: 16px;\n        box-shadow: none;\n      }\n\n      gap: 10px;\n      display: flex;\n\n      button {\n        margin-top: 3px;\n      }\n\n      .title {\n        word-break: break-word;\n        margin-bottom: 16px;\n      }\n\n      &-with-checkbox {\n        align-items: center;\n      }\n    }\n  }\n\n  .video-modal-about {\n    margin: 16px 0 32px;\n  }\n\n  .topics-post-link-container {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    font-size: 16px;\n    padding: 16px;\n\n    .header {\n      margin-right: 16px;\n      display: inline-block;\n    }\n\n    .topics-content {\n      display: flex;\n\n      .video-related-topics{\n        color: var(--color_primary_500);\n      }\n    }\n\n    .post-link {\n      display: block;\n      font-size: 14px;\n      color: var(--gray);\n      margin-left: auto;\n\n      &:hover {\n        color: var(--gray_dark1);\n      }\n    }\n  }\n\n  .info-content-grid {\n    padding: 0 0 1px;\n\n    .mini-card-container .title-tooltip {\n      max-width: 200px;\n    }\n  }\n\n  .related-videos {\n    margin: 0 0 32px;\n\n    > .title {\n      margin: 0 0 8px;\n    }\n  }\n\n  .related-videos-grid {\n    display: grid;\n    grid-gap: 16px;\n    grid-template-columns: repeat(3, minmax(250px, 1fr));\n  }\n}\n\n.chart-side-by-side {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  column-gap: 20px;\n}\n\n.video-modal-content .content .mini-card-container {\n  padding: 0;\n\n  .mini-card-container-title {\n    span {\n      align-self: flex-end;\n    }\n  }\n}\n\n@media only screen and (max-width: 600px) {\n  .topics-post-link-container {\n    display: none;\n  }\n\n  .video-modal-about {\n    display: none;\n  }\n\n  .video-modal-tag-cloud-card {\n    display: none;\n  }\n\n  .chart-side-by-side {\n    display: none;\n  }\n\n  .related-videos {\n    display: none;\n  }\n\n  .published-at {\n    display: none;\n  }\n\n  .CheckboxInput {\n    display: none;\n  }\n\n  div.checkbox[class*='dist_checkbox-styled'] {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
